import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Нужна помощь с выбором финансового решения?',
} satisfies TMessages
